import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "lodash";
import { mapActions, mapState } from "vuex";
import { DELETE_SCHEDULED_EMAIL, LOAD_PAGINATED_AUTOMATION_RECIPIENTS } from "../../store/automation-actions";
const NEVER_FETCHED = -1;
const MAX_COUNT = 9999999;
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "UpcomingRecipientsTable",
  props: {
    automationId: {
      type: [String, Number],
      required: true
    },
    campaignId: {
      type: [String, Number],
      required: true
    },
    lastOne: {
      type: Boolean,
      default: false
    },
    isRenewalAutomation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      lastTableFetchLength: NEVER_FETCHED
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["accountPreferences"])), {}, {
    tableOptions() {
      return {
        columns: this.isRenewalAutomation ? ["suppressed", "appId", "name", "email", "propertyAddress", "mortgage", "scheduled"] : ["suppressed", "appId", "name", "email", "mortgage", "scheduled"],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            suppressed: this.$t("global.words.suppressed"),
            appId: this.$t("global.doorr.appId"),
            name: this.$t("account.name"),
            email: this.$t("account.email"),
            propertyAddress: this.$t("global.doorr.propertyAddress"),
            mortgage: this.$t("global.doorr.mortgage"),
            scheduled: this.$t("global.doorr.scheduledDate")
          },
          perPage: 20,
          tabbable: false,
          skin: "table mb-0",
          columnsClasses: {
            suppressed: "w-10 text-center",
            appId: this.isRenewalAutomation ? "w-5" : "hidden-heading",
            name: "w-15",
            email: "w-20",
            propertyAddress: this.isRenewalAutomation ? "w-25" : "hidden-heading",
            mortgage: this.isRenewalAutomation ? "w-10" : "hidden-heading",
            scheduled: "w-80"
          },
          texts: {
            noResults: this.$t("automations.upcomingRecipients.noResults")
          },
          requestFunction: this.tableRequestFunction.bind(this),
          stickyHeader: true,
          pagination: {
            virtual: true
          }
        }
      };
    }
  }),
  watch: {
    loading(val) {
      this.$emit("loading", val);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AutomationStore", [LOAD_PAGINATED_AUTOMATION_RECIPIENTS, DELETE_SCHEDULED_EMAIL])), {}, {
    handleSelectRecipient: debounce(async function (rowData) {
      const {
        id
      } = rowData;
      await this.DELETE_SCHEDULED_EMAIL({
        automationId: this.automationId,
        campaignId: this.campaignId,
        scheduledEmailId: id
      });
    }, 200),
    refreshData() {
      this.lastTableFetchLength = NEVER_FETCHED;
      this.$refs.table.refresh();
    },
    handleGoToClientApp(rowData) {
      this.$emit("go-to-client", rowData.applicationInfo);
    },
    async tableRequestFunction(tableOptions) {
      const tableData = {
        data: [],
        count: MAX_COUNT
      };

      // since the backend :) is not sending how many rows are in total
      // we need to have a way to tell the table to stop fetching more data
      // so if the last fetch was empty, there is likely no more records to fetch
      if (this.lastTableFetchLength === 0) return tableData;
      const {
        page,
        limit
      } = tableOptions;
      const offset = (page - 1) * limit;
      const data = await this.LOAD_PAGINATED_AUTOMATION_RECIPIENTS({
        campaignId: this.campaignId,
        paginationData: {
          offset,
          limit
        }
      });
      let dataToShow = [];
      this.accountPreferences.includeExisting ? dataToShow = data : dataToShow = _filterInstanceProperty(data).call(data, item => !item.isExistingMortgage);
      this.lastTableFetchLength = data.length;
      tableData.data = dataToShow;
      return tableData;
    },
    handleTableLoading() {
      this.loading = true;
    },
    handleTableLoaded() {
      this.loading = false;
    }
  })
});